import { StaffFormModal } from "@/modules/staff/components/StaffFormModal";
import { StaffTable } from "@/modules/staff/components/StaffTable";
import { useUrlTableState } from "@/shared/hooks/useUrlState";

interface OrgStaffTabProps {
	organizationId: string;
}

export function OrgStaffTab({ organizationId }: OrgStaffTabProps) {
	const { page, limit, setPage } = useUrlTableState({ prefix: "staff" });

	return (
		<>
			<StaffTable
				organizationId={organizationId}
				page={page}
				limit={limit}
				onPageChange={setPage}
			/>
			<StaffFormModal organizationId={organizationId} organizations={[]} />
		</>
	);
}
